import axios from 'axios';
// import store from '@/store';


let instance = axios.create({
  baseURL: "http://www.energyst.cn/api",
  // baseURL: "http://192.168.2.4:8000/api",
  timeout: 5000,
});

// 请求拦截
instance.interceptors.request.use(
  (config) => {
    return config;
  });

// 响应拦截
instance.interceptors.response.use(
  (res) => {
    return res.data;
  }, (error) => {
    return Promise.reject(error);
  });

export default instance;
